import { CommonService } from '../_Services/common.service'; 
import { Component, Input, Output   } from '@angular/core'; 
import { NgxPaginationModule } from 'ngx-pagination'; 
import { FormsModule, Validators, NgForm } from '@angular/forms';


import { UserService } from '../_Services/user.service'; 

import { Router, ActivatedRoute } from '@angular/router';   

@Component({
  templateUrl: 'agency.component.html'
})
export class AgencyComponent {

    usefrs = [];  

    p: any = 1; 

    paginator = []; 
 

	constructor(private userService: UserService, private route:ActivatedRoute) { }
 
	pageChanged(page: Number) { 
		this.p = page;
		this.userService.getAgencyUsers(page).subscribe(result => {
                console.log(result.paginator);
                this.usefrs = result.data;
                this.paginator = result.paginator; 
            });  
	}
	ngOnInit() {   
		this.userService.getAgencyUsers(this.p).subscribe(result => {
                console.log(result);
                this.usefrs = result.data;
                this.paginator = result.paginator; 
            });  
	}
}




// WEBPACK FOOTER //
// ./src/app/users/agency.component.ts